import { render, staticRenderFns } from "./TazapayCard.vue?vue&type=template&id=4a71d856&scoped=true&"
import script from "./TazapayCard.vue?vue&type=script&lang=js&"
export * from "./TazapayCard.vue?vue&type=script&lang=js&"
import style0 from "./TazapayCard.vue?vue&type=style&index=0&id=4a71d856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71d856",
  null
  
)

export default component.exports